import { BrowserRouter, Routes, Route } from "react-router-dom";
import Login from "../pages/Login";
import Dashboard from "../pages/Dashboard";
import Plans from "../pages/Plans";
import AddPlan from "../pages/AddPlan";
import Schools from "../pages/Schools";
import AddSchool from "../pages/AddSchool";
import ProtectedLayout from "../layout/ProtectedLayout";
import SchoolDetails from "../pages/SchoolDetails";
import EditSchool from "../pages/EditSchool";
import SchoolAdminLogin from "../pages/SchoolAdminLogin";
import Payments from "../pages/Payments";
import ClassTestList from "../school/pages/exams/ClassTestList.jsx";
import InvoicePage from "../school/pages/fees/invoice";
import InvoiceSettings from "../school/pages/fees/InvoiceSettings";
import TeacherAttendanceCalendar from "../school/pages/TeacherAttendanceCalendar.jsx";
import TeacherList from "../school/pages/TeacherList";
import AddTeacher from "../school/pages/AddTeacher";
import TeacherDetails from "../school/pages/TeacherDetails";
import EditTeacher from "../school/pages/EditTeacher";
import FeesDashboard from "../school/pages/fees/FeesDashboard";
import FeeList from "../school/pages/fees/FeeList";
import GenerateFees from "../school/pages/fees/GenerateFees";
import FeeReceipt from "../school/pages/fees/FeeReceipt";
// School Admin Pages
import LibraryCategoryAdd from "../school/pages/library/LibraryCategoryAdd";
import AddHostel from "../school/pages/hostel/AddHostel";
import HostelList from "../school/pages/hostel/HostelList";
import HostelRooms from "../school/pages/hostel/HostelRooms";
import RoomBeds from "../school/pages/hostel/RoomBeds";
import AllocateStudent from "../school/pages/hostel/AllocateStudent";
import HostelFees from "../school/pages/hostel/HostelFees";
import MessPlans from "../school/pages/hostel/MessPlans";
import AssignStudentMess from "../school/pages/hostel/AssignStudentMess";

import MessHoliday from "../school/pages/hostel/MessHoliday";

import ClassArchivedList from "../school/pages/ClassArchivedList";
import UploadResultFile from "../school/pages/exams/UploadResultFile";
import SchoolLayout from "../school/layout/SchoolLayout";
import SchoolAdminDashboard from "../school/pages/SchoolAdminDashboard";
import Students from "../school/pages/Students";
import AddStudent from "../school/pages/AddStudent";
import SubjectList from "../school/pages/subjects/SubjectList";
import AddSubject from "../school/pages/subjects/AddSubject";
import ClassList from "../school/pages/ClassList";
import AddClass from "../school/pages/AddClass";       // ⭐ NEW
import SectionList from "../school/pages/SectionList";
import AddSection from "../school/pages/AddSection";   // ⭐ NEW
import StudentDetails from "../school/pages/StudentDetails";
import StudentAttendance from "../school/pages/StudentAttendance.jsx";
import ResultFileList from "../school/pages/exams/ResultFileList";
import ExamList from "../school/pages/exams/ExamList";
import ArchivedExams from "../school/pages/exams/ArchivedExams";
import AddExam from "../school/pages/exams/AddExam";
import AddResult from "../school/pages/exams/AddResult";
import ResultList from "../school/pages/exams/ResultList";
import LibraryDashboard from "../school/pages/library/LibraryDashboard";
import BookCategoryList from "../school/pages/library/BookCategoryList";
import TeacherAttendance from "../school/pages/TeacherAttendance";
import TeacherLeaveApproval from "../school/pages/TeacherLeaveApproval";
import BookList from "../school/pages/library/BookList";
import AddBook from "../school/pages/library/AddBook";
import BookCopies from "../school/pages/library/BookCopies";
import IssueBook from "../school/pages/library/IssueBook";
import ReturnBook from "../school/pages/library/ReturnBook";
import EventList from "../school/pages/events/EventList";
import AddEvent from "../school/pages/events/AddEvent";
import NoticeList from "../school/pages/notices/NoticeList";
import AddNotice from "../school/pages/notices/AddNotice";
import TeacherSalaryDashboard from "../school/pages/salary/TeacherSalaryDashboard";
import GenerateTeacherSalary from "../school/pages/salary/GenerateTeacherSalary";
import PendingTeacherSalary from "../school/pages/salary/PendingTeacherSalary";
import PaidTeacherSalary from "../school/pages/salary/PaidTeacherSalary";
import StaffList from "../school/pages/staff/StaffList";
import ArchivedStaff from "../school/pages/staff/ArchivedStaff";
import AddStaff from "../school/pages/staff/AddStaff";
import StudentMessList from "../school/pages/hostel/StudentMessList";
import EditStaff from "../school/pages/staff/EditStaff";
import StaffSalary from "../school/pages/staff/StaffSalary";
import AddonFeeList from "../school/pages/fees/AddonFeeList";
import AddonFeeAdd from "../school/pages/fees/AddonFeeAdd";
import InventoryList from "../school/pages/inventory/InventoryList";
import InventoryEdit from "../school/pages/inventory/InventoryEdit";
import InventoryAdd from "../school/pages/inventory/InventoryAdd";
import InventoryDashboard from "../school/pages/inventory/InventoryDashboard";
import InventoryCategoryAdd from "../school/pages/inventory/InventoryCategoryAdd";
import InventoryCategoryList from "../school/pages/inventory/InventoryCategoryList";
import EditStudent from "../school/pages/EditStudent";
import SchoolPages from "../school/pages/privacy/SchoolPages.jsx";
import SchoolGallery from "../school/pages/privacy/SchoolGallery.jsx";
import ArchivedTeachers from "../school/pages/ArchivedTeachers.jsx";
import HolidayList from "../school/pages/holidays/HolidayList";
import AddHoliday from "../school/pages/holidays/AddHoliday";
import BusList from "../school/pages/transport/BusList";
import AddBus from "../school/pages/transport/AddBus";
import BusDetail from "../school/pages/transport/BusDetail";
import TimetableDashboard
  from "../school/pages/timetable/TimetableDashboard.jsx";
import UploadResultExcel from "../school/pages/exams/UploadResultExcel.jsx";
import TimetableEditor from "../school/pages/timetable/TimetableEditor.jsx";
import EditBus from "../school/pages/transport/EditBus.jsx";
import WeeklyTimetableList from "../school/pages/timetable/WeeklyTimetableList.jsx";
import TimetableView from "../school/pages/timetable/TimetableView.jsx";

import CareerGuideList from "../school/pages/career/CareerGuideList";
import AddCareerCourse from "../school/pages/career/AddCareerCourse";
import EditCareerCourse from "../school/pages/career/EditCareerCourse";

// IMPORT
import ExpenseList from "../school/pages/expense/ExpenseList";
import AddExpense from "../school/pages/expense/AddExpense";
import AdminOrderList from "../school/pages/orders/AdminOrderList";
import AdminComplaintList from "../school/pages/complaints/AdminComplaintList";
export default function AppRouter() {
  return (
    <BrowserRouter>
      <Routes>
        {/* SUPER ADMIN LOGIN */}
        <Route path="/login" element={<Login />} />
        {/* LIBRARY MODULE */}
        {/* LIBRARY */}
// ROUTES
        <Route

          path="/school-admin/orders"

          element={

            <SchoolLayout>

              <AdminOrderList />

            </SchoolLayout>

          }

        />
        <Route

  path="/school-admin/complaints"

  element={

    <SchoolLayout>

      <AdminComplaintList />

    </SchoolLayout>

  }

/>
        <Route
          path="/school-admin/expense"
          element={
            <SchoolLayout>
              <ExpenseList />
            </SchoolLayout>
          }
        />

        <Route
          path="/school-admin/expense/add"
          element={
            <SchoolLayout>
              <AddExpense />
            </SchoolLayout>
          }
        />
        <Route
          path="/school-admin/career"
          element={
            <SchoolLayout>
              <CareerGuideList />
            </SchoolLayout>
          }
        />

        <Route
          path="/school-admin/career/add"
          element={
            <SchoolLayout>
              <AddCareerCourse />
            </SchoolLayout>
          }
        />

        <Route
          path="/school-admin/career/edit/:id"
          element={
            <SchoolLayout>
              <EditCareerCourse />
            </SchoolLayout>
          }
        />

        <Route
          path="/school-admin/transport/buses"
          element={
            <SchoolLayout>
              <BusList />
            </SchoolLayout>
          }
        />
        <Route
          path="/school-admin/transport/buses/edit/:id"
          element={<EditBus />}
        />
        <Route
          path="/school-admin/transport/buses/add"
          element={
            <SchoolLayout>
              <AddBus />
            </SchoolLayout>
          }
        />

        <Route
          path="/school-admin/transport/buses/:id"
          element={
            <SchoolLayout>
              <BusDetail />
            </SchoolLayout>
          }
        />



        <Route
          path="/school-admin/library"
          element={
            <SchoolLayout>
              <LibraryDashboard />
            </SchoolLayout>
          }
        />

        <Route
          path="/school-admin/timetable/weekly"
          element={
            <SchoolLayout>
              <WeeklyTimetableList />
            </SchoolLayout>
          }
        />
        <Route path="/school-admin/timetable" element={
          <SchoolLayout><TimetableDashboard /></SchoolLayout>
        } />

        <Route path="/school-admin/timetable/edit" element={
          <SchoolLayout><TimetableEditor /></SchoolLayout>
        } />

        <Route path="/school-admin/timetable/view" element={
          <SchoolLayout><TimetableView /></SchoolLayout>
        } />
        <Route
          path="/school-admin/library"
          element={
            <SchoolLayout>
              <LibraryDashboard />
            </SchoolLayout>
          }
        />
        {/* HOLIDAYS */}
        <Route
          path="/school-admin/results/upload-excel"
          element={
            <SchoolLayout>
              <UploadResultExcel />
            </SchoolLayout>
          }
        />
        <Route
          path="/school-admin/holidays"
          element={
            <SchoolLayout>
              <HolidayList />
            </SchoolLayout>
          }
        />
        <Route
          path="/school-admin/teachers/archived"
          element={
            <SchoolLayout>
              <ArchivedTeachers />
            </SchoolLayout>
          }
        />
        <Route
          path="/school-admin/holidays/add"
          element={
            <SchoolLayout>
              <AddHoliday />
            </SchoolLayout>
          }
        />

        <Route
          path="/school-admin/settings/pages"
          element={
            <SchoolLayout>
              <SchoolPages />
            </SchoolLayout>
          }
        />
        <Route
          path="/school-admin/inventory/edit/:id"
          element={<InventoryEdit />}
        />

        <Route
          path="/school-admin/settings/gallery"
          element={
            <SchoolLayout>
              <SchoolGallery />
            </SchoolLayout>
          }
        />

        <Route
          path="/school-admin/exams/archived"
          element={
            <SchoolLayout>
              <ArchivedExams />
            </SchoolLayout>
          }
        />




        {/* ================= LIBRARY ================= */}

        <Route
          path="/school-admin/library"
          element={
            <SchoolLayout>
              <LibraryDashboard />
            </SchoolLayout>
          }
        />

        <Route
          path="/school-admin/library/categories"
          element={
            <SchoolLayout>
              <BookCategoryList />
            </SchoolLayout>
          }
        />

        <Route
          path="/school-admin/library/categories/add"
          element={
            <SchoolLayout>
              <LibraryCategoryAdd />
            </SchoolLayout>
          }
        />

        <Route
          path="/school-admin/library/books"
          element={
            <SchoolLayout>
              <BookList />
            </SchoolLayout>
          }
        />
        <Route
          path="/school-admin/students/:id/attendance"
          element={
            <SchoolLayout>
              <StudentAttendance />
            </SchoolLayout>
          }
        />
        <Route
          path="/school-admin/library/books/add"
          element={
            <SchoolLayout>
              <AddBook />
            </SchoolLayout>
          }
        />

        <Route
          path="/school-admin/library/books/:bookId/copies"
          element={
            <SchoolLayout>
              <BookCopies />
            </SchoolLayout>
          }
        />

        {/* ✅ FIXED PATH NAMES */}
        <Route
          path="/school-admin/library/issue"
          element={
            <SchoolLayout>
              <IssueBook />
            </SchoolLayout>
          }
        />

        <Route
          path="/school-admin/library/return"
          element={
            <SchoolLayout>
              <ReturnBook />
            </SchoolLayout>
          }
        />





        {/* SUPER ADMIN PANEL */}
        <Route
          path="/"
          element={
            <ProtectedLayout>
              <Dashboard />
            </ProtectedLayout>
          }
        />

        <Route path="/plans" element={<ProtectedLayout><Plans /></ProtectedLayout>} />
        <Route path="/plans/add" element={<ProtectedLayout><AddPlan /></ProtectedLayout>} />

        <Route path="/schools" element={<ProtectedLayout><Schools /></ProtectedLayout>} />
        <Route path="/schools/add" element={<ProtectedLayout><AddSchool /></ProtectedLayout>} />
        <Route path="/schools/:id" element={<SchoolDetails />} />
        <Route path="/schools/edit/:id" element={<EditSchool />} />

        <Route path="/payments" element={<ProtectedLayout><Payments /></ProtectedLayout>} />

        {/* SCHOOL ADMIN LOGIN */}
        <Route path="/school-admin/login" element={<SchoolAdminLogin />} />
        {/* TEACHER ROUTES */}
        <Route path="/school-admin/teachers" element={<SchoolLayout><TeacherList /></SchoolLayout>} />
        <Route path="/school-admin/teachers/add" element={<SchoolLayout><AddTeacher /></SchoolLayout>} />
        <Route path="/school-admin/teachers/:id" element={<SchoolLayout><TeacherDetails /></SchoolLayout>} />
        <Route path="/school-admin/teachers/edit/:id" element={<SchoolLayout><EditTeacher /></SchoolLayout>} />
        {/* TEACHER ATTENDANCE */}
        <Route
          path="/school-admin/teacher-attendance"
          element={
            <SchoolLayout>
              <TeacherAttendance />
            </SchoolLayout>
          }
        />

        {/* TEACHER LEAVE APPROVAL */}
        <Route
          path="/school-admin/teacher-leaves"
          element={
            <SchoolLayout>
              <TeacherLeaveApproval />
            </SchoolLayout>
          }
        />
        {/* SCHOOL ADMIN PANEL */}
        <Route
          path="/school-admin/dashboard"
          element={
            <SchoolLayout>
              <SchoolAdminDashboard />
            </SchoolLayout>
          }
        />

        {/* STUDENTS */}
        <Route
          path="/school-admin/students"
          element={
            <SchoolLayout>
              <Students />
            </SchoolLayout>
          }
        />

        <Route
          path="/school-admin/students/add"
          element={
            <SchoolLayout>
              <AddStudent />
            </SchoolLayout>
          }
        />

        {/* CLASSES */}
        <Route
          path="/school-admin/classes"
          element={
            <SchoolLayout>
              <ClassList />
            </SchoolLayout>
          }
        />

        <Route
          path="/school-admin/classes/add"
          element={
            <SchoolLayout>
              <AddClass />
            </SchoolLayout>
          }
        />

        {/* HOSTEL MANAGEMENT */}
        <Route
          path="/school-admin/hostels"
          element={
            <SchoolLayout>
              <HostelList />
            </SchoolLayout>
          }
        />

        <Route
          path="/school-admin/hostels/add"
          element={
            <SchoolLayout>
              <AddHostel />
            </SchoolLayout>
          }
        />

        <Route
          path="/school-admin/hostels/:hostelId/rooms"
          element={
            <SchoolLayout>
              <HostelRooms />
            </SchoolLayout>
          }
        />

        <Route
          path="/school-admin/hostels/rooms/:roomId/beds"
          element={
            <SchoolLayout>
              <RoomBeds />
            </SchoolLayout>
          }
        />

        <Route
          path="/school-admin/hostels/allocate"
          element={
            <SchoolLayout>
              <AllocateStudent />
            </SchoolLayout>
          }
        />

        <Route
          path="/school-admin/hostels/fees"
          element={
            <SchoolLayout>
              <HostelFees />
            </SchoolLayout>
          }
        />

        {/* ================= HOSTEL MESS ================= */}
        <Route
          path="/school-admin/hostels/plans"
          element={
            <SchoolLayout>
              <MessPlans />
            </SchoolLayout>
          }
        />

        <Route
          path="/school-admin/hostels/assign"
          element={
            <SchoolLayout>
              <AssignStudentMess />
            </SchoolLayout>
          }
        />

        <Route
          path="/school-admin/hostels/students"
          element={
            <SchoolLayout>
              <StudentMessList />
            </SchoolLayout>
          }
        />

        <Route
          path="/school-admin/hostels/holidays"
          element={
            <SchoolLayout>
              <MessHoliday />
            </SchoolLayout>
          }
        />
        {/* SECTIONS */}
        <Route
          path="/school-admin/sections"
          element={
            <SchoolLayout>
              <SectionList />
            </SchoolLayout>
          }
        />
        {/* TEACHER SALARY SYSTEM */}
        <Route
          path="/school-admin/salary"
          element={
            <SchoolLayout>
              <TeacherSalaryDashboard />
            </SchoolLayout>
          }
        />

        <Route
          path="/school-admin/salary/generate"
          element={
            <SchoolLayout>
              <GenerateTeacherSalary />
            </SchoolLayout>
          }
        />

        <Route
          path="/school-admin/salary/pending"
          element={
            <SchoolLayout>
              <PendingTeacherSalary />
            </SchoolLayout>
          }
        />

        <Route
          path="/school-admin/salary/paid"
          element={
            <SchoolLayout>
              <PaidTeacherSalary />
            </SchoolLayout>
          }
        />
        <Route
          path="/school-admin/sections/add"
          element={
            <SchoolLayout>
              <AddSection />
            </SchoolLayout>
          }
        />

        {/* STAFF */}
        <Route
          path="/school-admin/staff"
          element={
            <SchoolLayout>
              <StaffList />
            </SchoolLayout>
          }
        />
        <Route
          path="/school-admin/staff/archived"
          element={
            <SchoolLayout>
              <ArchivedStaff />
            </SchoolLayout>
          }
        />
        <Route
          path="/school-admin/staff/add"
          element={
            <SchoolLayout>
              <AddStaff />
            </SchoolLayout>
          }
        />
        <Route
          path="/school-admin/staff/edit/:id"
          element={
            <SchoolLayout>
              <EditStaff />
            </SchoolLayout>
          }
        />
        <Route
          path="/school-admin/staff/salary"
          element={
            <SchoolLayout>
              <StaffSalary />
            </SchoolLayout>
          }
        />
        <Route
          path="/school-admin/addon-fees"
          element={
            <SchoolLayout>
              <AddonFeeList />
            </SchoolLayout>
          }
        />
        <Route
          path="/school-admin/addon-fees/add"
          element={
            <SchoolLayout>
              <AddonFeeAdd />
            </SchoolLayout>
          }
        />
        {/* ARCHIVED CLASSES */}
        <Route
          path="/school-admin/classes/archived"
          element={
            <SchoolLayout>
              <ClassArchivedList />
            </SchoolLayout>
          }
        />
        {/* SUBJECTS */}
        <Route
          path="/school-admin/subjects"
          element={
            <SchoolLayout>
              <SubjectList />
            </SchoolLayout>
          }
        />

        <Route
          path="/school-admin/subjects/add"
          element={
            <SchoolLayout>
              <AddSubject />
            </SchoolLayout>
          }
        />


        <Route
          path="/school-admin/students/:id"
          element={
            <SchoolLayout>
              <StudentDetails />
            </SchoolLayout>
          }
        />
        {/* TEACHER ROUTES */}
        <Route path="/school-admin/teachers" element={<SchoolLayout><TeacherList /></SchoolLayout>} />
        <Route path="/school-admin/teachers/add" element={<SchoolLayout><AddTeacher /></SchoolLayout>} />
        <Route path="/school-admin/teachers/:id" element={<SchoolLayout><TeacherDetails /></SchoolLayout>} />
        <Route path="/school-admin/teachers/edit/:id" element={<SchoolLayout><EditTeacher /></SchoolLayout>} />
        <Route
          path="/school-admin/students/details/:id"
          element={
            <SchoolLayout>
              <StudentDetails />
            </SchoolLayout>
          }
        />
        <Route
          path="/school-admin/results/files"
          element={
            <SchoolLayout>
              <ResultFileList />
            </SchoolLayout>
          }
        />
        <Route path="/school-admin/inventory" element={<SchoolLayout><InventoryList /></SchoolLayout>} />
        <Route path="/school-admin/inventory/add" element={<SchoolLayout><InventoryAdd /></SchoolLayout>} />
        <Route path="/school-admin/inventory/dashboard" element={<SchoolLayout><InventoryDashboard /></SchoolLayout>} />
        <Route
          path="/school-admin/students/edit/:id"
          element={
            <SchoolLayout>
              <EditStudent />
            </SchoolLayout>
          }
        />

        {/* EVENTS */}
        <Route
          path="/school-admin/events"
          element={
            <SchoolLayout>
              <EventList />
            </SchoolLayout>
          }
        />

        <Route
          path="/school-admin/events/add"
          element={
            <SchoolLayout>
              <AddEvent />
            </SchoolLayout>
          }
        />
        <Route
          path="/school-admin/invoice-settings"
          element={
            <SchoolLayout>
              <InvoiceSettings />
            </SchoolLayout>
          }
        />

        <Route
          path="/school-admin/invoices"
          element={
            <SchoolLayout>
              <InvoicePage />
            </SchoolLayout>
          }
        />
        <Route
          path="/school-admin/class-tests"
          element={
            <SchoolLayout>
              <ClassTestList />
            </SchoolLayout>
          }
        />
        {/* NOTICES */}
        <Route
          path="/school-admin/notices"
          element={
            <SchoolLayout>
              <NoticeList />
            </SchoolLayout>
          }
        />

        <Route
          path="/school-admin/notices/add"
          element={
            <SchoolLayout>
              <AddNotice />
            </SchoolLayout>
          }
        />

        <Route
          path="/school-admin/results/upload-file"
          element={
            <SchoolLayout>
              <UploadResultFile />
            </SchoolLayout>
          }
        />
        <Route path="/school-admin/exams" element={<SchoolLayout><ExamList /></SchoolLayout>} />

        <Route path="/school-admin/exams/add" element={<SchoolLayout><AddExam /></SchoolLayout>} />

        <Route
          path="/school-admin/inventory/categories"
          element={
            <SchoolLayout>
              <InventoryCategoryList />
            </SchoolLayout>
          }
        />
        <Route path="/school-admin/teacher-attendance/calendar" element={<SchoolLayout><TeacherAttendanceCalendar /></SchoolLayout>} />
        <Route
          path="/school-admin/inventory/categories/add"
          element={
            <SchoolLayout>
              <InventoryCategoryAdd />
            </SchoolLayout>
          }
        />
        <Route path="/school-admin/results" element={<SchoolLayout><ResultList /></SchoolLayout>} />
        <Route path="/school-admin/fees" element={<SchoolLayout><FeesDashboard /></SchoolLayout>} />
        <Route path="/school-admin/fees/list" element={<SchoolLayout><FeeList /></SchoolLayout>} />
        <Route path="/school-admin/fees/generate" element={<SchoolLayout><GenerateFees /></SchoolLayout>} />
        <Route path="/school-admin/fees/receipt/:id" element={<SchoolLayout><FeeReceipt /></SchoolLayout>} />
      </Routes>
    </BrowserRouter>
  );
}